var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.82,
    height: 25.396,
    viewBox: "0 0 19.82 25.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-location-5752337",
    transform: "translate(-143.846 -14.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37618",
    "data-name": "Path 37618",
    d: "M154.757,20.492a4.439,4.439,0,1,0,3.139,1.3,4.439,4.439,0,0,0-3.139-1.3Zm2.6,1.839a3.676,3.676,0,1,1-2.6-1.079,3.676,3.676,0,0,1,2.6,1.079Zm-9.389-4.784a9.627,9.627,0,0,1,13.577,0,8.839,8.839,0,0,1,2.621,6.375,11.916,11.916,0,0,1-2.589,7.167l-5.83,7.564a1.244,1.244,0,0,1-1.979,0l-5.831-7.564a11.916,11.916,0,0,1-2.589-7.167,8.84,8.84,0,0,1,2.621-6.375Z",
    transform: "translate(-1)",
    fill: "#61277f",
    stroke: "#f6f6f6",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLocation);
export default __webpack_public_path__ + "static/media/sidebar-location.ecd450ddc04eeee626c2b3a38fbf2095.svg";
export { ForwardRef as ReactComponent };